import { useMemo } from 'react'
import { IoIosClose } from 'react-icons/io'
import { ClipLoader } from 'react-spinners'
import { Text, HintBox, useMainContext, formatNumber } from '..'
import { SOCKET_URL } from '../../../core/constants/urls'
import CoinImg from '../../../components/common/CoinImg'

const AddStakingModal = ({ detail, onClose, onSubmit, loading }) => {
	const {
		main: { lang },
	} = useMainContext()
	const onboard = useMemo(() => {
		if (!!detail.data) {
			const plan = detail.data.plan
			const amount = detail.data.amount
			return [
				{
					name: 'coin',
					content: (
						<div className={'flex items-center gap-2'}>
							<CoinImg size={28} id={plan.currency} />
							<span className={'mt-1'}>{plan.currency.toUpperCase()}</span>
						</div>
					),
				},
				{
					name: 'staking-type',
					content: (
						<div className={'flex items-center gap-1'}>
							<span>{plan.periodDays}</span>
							<Text tid={'days'} />
						</div>
					),
				},
				{
					name: 'staking-amount',
					content: (
						<span>{`${formatNumber(amount, {
							type: plan.currency,
						})} ${plan.currency.toUpperCase()}`}</span>
					),
				},
				{
					name: 'staking-profit',
					content: (
						<span dir={'ltr'}>
							{`${formatNumber((amount * plan.settlements * plan.interestRate) / 100, {
								type: plan.currency,
							})} ${plan.currency.toUpperCase()}`}
						</span>
					),
				},
				{
					name: 'staking-profit-per-month',
					content: (
						<span dir={'ltr'}>
							{`${formatNumber((amount * plan.interestRate) / 100, {
								type: plan.currency,
							})} ${plan.currency.toUpperCase()}`}
						</span>
					),
				},
				{
					name: 'staking-date',
					content: <span>{`${new Date().toLocaleString(lang === 'fa' ? 'fa-IR' : 'en-US')}`}</span>,
				},
			]
		}
		return []
	}, [detail])

	if (!detail.show) return <></>
	return (
		<div
			className={
				'w-screen h-screen left-0 top-0 z-[1000003] fixed backdrop-blur flex items-center justify-center px-2'
			}
		>
			<div className={'lg:w-[480px] w-full rounded-md dark:bg-darkPrimaryBg bg-slate-100'}>
				<div
					className={
						'w-full rounded-t-md h-[64px] flex bg-slate-200 dark:bg-darkPrimaryBg items-center justify-center relative'
					}
				>
					<Text tid={'staking-add-modal-header'} />
					<div className={'absolute left-2 top-2 cursor-pointer p-1'} onClick={onClose}>
						<IoIosClose size={20} />
					</div>
				</div>

				<div className={'flex flex-col gap-5 py-3 px-5'}>
					<HintBox body={['add-staking-hint-1', 'add-staking-hint-2']} type={'info'} />
					<div className={'flex flex-col gap-3'}>
						{onboard.map((x, idx) => {
							const isLast = idx === onboard.length - 1
							return (
								<div
									key={x.name}
									className={`flex justify-between items-center cursor-pointer  
                    ${isLast ? '' : 'border-b-[1px]'} border-cBlue/50
                     dark:text-slate-100 font-semibold text-sm border-opacity-20 px-2 pb-2`}
								>
									<Text tid={x.name} />
									{x.content}
								</div>
							)
						})}

						<div
							className={
								'rounded-md flex items-center mt-3 justify-center h-[44px] w-full bg-active text-slate-200 text-sm font-semibold cursor-pointer'
							}
							onClick={onSubmit}
						>
							{loading ? <ClipLoader size={20} /> : <Text tid={'submit-and-do'} />}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AddStakingModal
